import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyPdfExportPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PdfExportContainer" */ '../src/PdfExport/PdfExportPage.tsx'
			)
		).PdfExportPage,
});
